import React from "react";
import {useDispatch, connect} from 'react-redux';
import { Paper } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TitleIcon from '@mui/icons-material/Title';
import CloseIcon from '@mui/icons-material/Close';

import preloaded from '../utils/data.json';

const mapStateToProps = (state) => {
    return {
        map: state.MapReducer
    }
}

const MapTitle = (props) => {
    const dispatch = useDispatch();

    const [showPanel, setShowPanel] = React.useState(true);
    
    return <div>
    {
        !showPanel?(
            <IconButton style={{color: 'gray'}} onClick={()=>{setShowPanel(true)}} aria-label="delete">
                <TitleIcon />
            </IconButton>):''
    }

    <Paper  elevation={0} 
            style={{
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                padding: 10,
                marginRight: 40,
                minWidth: 150,
                display:showPanel?'block':'none',
                paddingLeft: 16,
                maxWidth: 'calc(100vh - 150px)',
                maxHeight: 'calc(100vh - 90px)',
                overflowY: 'auto',
                borderRadius: 10, 
                backgroundColor:'rgba(255, 255, 255, 0.75)'}
            } 
            onClick={()=>{setShowPanel(false)}}>

        <span>
            {
                Object.entries(preloaded).map((entry) => {
                    if (props.map.activeField=="val") {
                        if(props.map.activeLayer.replace("allum_project:","") === entry[1].name){
                            return entry[1].title
                        }
                    } else {
                        if(props.map.activeField === entry[1].name.replace("allum_project:","")){
                            return entry[1].title
                        }
                    }
                })
            }
        </span>

    </Paper>
    </div>
}

export default connect(mapStateToProps)(MapTitle);